var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-box',{staticClass:"ads__container",attrs:{"gutter":_vm.gutter,"tag":_vm.tag,"id":_vm.trackId,"data-name":_vm.trackId},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }